import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "发票邮寄")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "form-dialog__content"
}

import { ref, defineModel } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-open-dialog-address',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formRef = ref(null);
const formData = _useModel<BasicInformationData['addressList']>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    model: formData.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.isDefault)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(BaseFormItem), {
                  label: "收件人",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      class: "form-dialog__w280",
                      type: "text",
                      placeholder: "请输入",
                      disabled: "",
                      modelValue: item.name,
                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(BaseFormItem), {
                  label: "联系电话",
                  prop: "phone"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      class: "form-dialog__w280",
                      type: "text",
                      placeholder: "请输入",
                      disabled: "",
                      modelValue: item.phone,
                      "onUpdate:modelValue": ($event: any) => ((item.phone) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(BaseFormItem), {
                  label: "企业地址",
                  prop: "mailAddress"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      class: "form-dialog__w280",
                      type: "text",
                      placeholder: "请输入",
                      disabled: "",
                      modelValue: item.mailAddress,
                      "onUpdate:modelValue": ($event: any) => ((item.mailAddress) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(BaseFormItem), {
                  label: "邮箱",
                  prop: "email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseInput), {
                      class: "form-dialog__w280",
                      type: "tel",
                      placeholder: "请输入",
                      disabled: "",
                      modelValue: item.email,
                      "onUpdate:modelValue": ($event: any) => ((item.email) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})